module.exports = __webpack_public_path__ + "images/feature/move-2-c3339bd8cc1b2da60c767d2c2397fdf3.jpg";